/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
/**
 * Combines product images with default image, ensuring default image is first if not already present
 * @param productImages - Array of product image URLs
 * @param defaultImage - Default image URL to prepend if not already in array
 * @returns Combined array with default image first (if provided and not duplicate)
 */

export const getImagesWithDefault = (
  productImages: string[] = [],
  defaultImage?: string
): string[] => {
  if (!defaultImage) return productImages;
  const withoutDefault = productImages.filter((img) => img !== defaultImage);
  return [defaultImage, ...withoutDefault];
};
